import {useMemo} from 'react'
import {useSelectedVariantContext} from '../components/step2/context/SelectedVariantContext'
import {getSideFromVariants} from '../components/step2/product-variant/helpers/getSideFromVariants'
import _ from 'lodash'
import {hasInvalidVariantDimensions} from '../components/step2/product-variant/helpers/hasInvalidVariantDimensions'

const optionalSides = ['All', 'Safezone']

export function useEditorSides() {
    const {
        state: {selectedAttribute, selectedSide, pickerVariants, product, variants},
    } = useSelectedVariantContext()

    const hasMockups = product?.mockups.length > 0

    const sidesFromMockups = useMemo(() => {
        if (!selectedAttribute) return []

        const side = selectedAttribute.safeZone

        return Object.keys(side)
    }, [selectedAttribute])

    const hasInvalidDimensions = hasInvalidVariantDimensions(variants)

    const isOptionalSide = useMemo(() => {
        return optionalSides.includes(selectedSide)
    }, [selectedSide])

    const sidesFromVariants = useMemo(() => {
        const validVariants = hasInvalidDimensions ? [] : pickerVariants
        return getSideFromVariants(validVariants)
    }, [hasInvalidDimensions, pickerVariants])

    const sides = hasMockups ? sidesFromMockups : sidesFromVariants

    return {
        sides,
        hasInvalidDimensions,
        isOptionalSide,
        selectedSide,
        optionalSides,
    }
}

